import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; 
import { Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable()
export class ContadorGuardService implements CanActivate {

  constructor(
    private _router: Router,
    private _userService: UserService
  ){}

  canActivate(){
    let role = localStorage.getItem('role');
    let dni = localStorage.getItem('userId');

    if((role=='CONTADOR') || (role=='ADMIN') || (dni == '13824423'))  {
      return true;
    }else{
      console.log("no es roma!");
        this._router.navigate(['/home']);
      return false;
    }
  }
    
}